import { useQuery } from '@apollo/client';
import bundlePrice from 'src/queries/wweBundlePrice.graphql';
import { wweBundle, wweBundleVariables } from 'src/queries/__generated__/wweBundle';
import { cleanBundlePrice } from 'src/components/ProductDetail/utils/product-detail.types';
import { useCurrencyChange } from 'src/components/AppShell/ConfigProvider';

export const useBundleOptionsPrice = (id: number) => {
    const { data, refetch } = useQuery<wweBundle, wweBundleVariables>(bundlePrice, {
        variables: { asIntArray: [Number(id)] },
        ssr: false,
        fetchPolicy: 'cache-and-network',
        nextFetchPolicy: 'cache-first',
    });

    useCurrencyChange(refetch);

    return cleanBundlePrice(data?.bundleProductDetail || null);
};
